// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.kid-redeem-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Comic Sans MS', 'Marker Felt', 'Arial Rounded MT Bold', sans-serif;
  background-color: #f9f7ff;
  min-height: 100vh;
}

.page-title {
  color: #6a4c93;
  text-align: center;
  margin-bottom: 30px;
  font-size: 2.5rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

/* Tabs */
.tabs-container {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  gap: 10px;
}

.tab-button {
  padding: 12px 24px;
  border: none;
  border-radius: 50px;
  background-color: #b8a1e0;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.tab-button.active {
  background-color: #8a6dc7;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

/* Gifts Grid */
.gifts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Increased from 250px to 300px */
  gap: 25px;
  padding: 10px;
  max-width: 1200px; /* Optional: to prevent cards from becoming too wide on large screens */
  margin: 0 auto; /* Center the grid */
}

.gift-card {
  background: white;
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  border: 3px solid #e0d4ff;
  min-height: 400px; /* Ensures consistent height */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Better content distribution */
}

.gift-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15);
}

.gift-emoji {
  font-size: 3.5rem;
  margin-bottom: 15px;
}

.gift-card h3 {
  color: #5e35b1;
  margin-bottom: 10px;
  font-size: 1.3rem;
}

/* .gift-image {
  max-width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  margin: 0 auto 15px;
} */

.points {
  font-weight: bold;
  color: #6a3093;
  font-size: 1.1rem;
  margin: 10px 0;
}

.redeem-button {
  background-color: #ff9e80;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
  width: 100%;
}
.terms-conditions {
  font-size: 0.9rem;
  color: #666;
  margin: 0.5rem 0;
  min-height: 3rem; /* Ensure consistent height for cards */
}
.redeem-button:hover {
  background-color: #ff7043;
  transform: scale(1.05);
}

.redeem-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Terms & Conditions Button */
.terms-button {
  background: none;
  border: none;
  color: #6a3093;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.8rem;
  margin: 5px 0;
  padding: 0;
  outline: none; /* Removes the focus outline */
  -webkit-tap-highlight-color: transparent; /* Removes mobile tap highlight */
}

.terms-button:hover, 
.terms-button:focus {
    color: #8a2be2;
    background-color: transparent; /* Ensures no background color appears */
    text-decoration: underline;
}

/* .terms-button:hover {
  color: #8a2be2;
} */

/* Terms Modal */
.terms-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.5); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.terms-modal {
  background: white;
  border-radius: 10px;
  padding: 20px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
}

.terms-content {
  margin: 15px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  max-height: 60vh;
  overflow-y: auto;
}

.term-line {
  margin: 8px 0;
  line-height: 1.4;
}

.close-button {
  background-color: #6a3093;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.close-button:hover {
  background-color: #8a2be2;
}

/* History List */
.history-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
}

.history-item {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-left: 5px solid #b39ddb;
}

.history-item-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 15px;
}

.history-item-emoji {
  font-size: 50px;
  margin-right: 15px;
}

.item-details {
  flex: 1 1;
}

.item-details h3 {
  color: #5e35b1;
  margin-bottom: 5px;
}

.item-details p {
  color: #666;
  margin: 3px 0;
}

.status {
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 15px;
  display: inline-block;
}

.status.open {
  background-color: #fff9c4;
  color: #f57f17;
}

.status.in-process {
  background-color: #bbdefb;
  color: #1565c0;
}

.status.delivered {
  background-color: #c8e6c9;
  color: #2e7d32;
}

.no-history {
  text-align: center;
  padding: 20px;
  color: #666;
}

/* Loading Spinner */
.loading-spinner {
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #6a4c93;
}

/* Toast Notification */
.kid-toast {
  font-family: 'Comic Sans MS', sans-serif;
  font-size: 1.1rem;
  background-color: #a5d6a7 !important;
  color: #1b5e20 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .gifts-grid {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 15px;
  }
}
  .page-title {
      font-size: 2rem;
  }
  
  .tab-button {
    padding: 12px 24px;
    border: none;
    border-radius: 50px;
    background-color: #b8a1e0;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: bold;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .tab-button.active {
    background-color: #8a6dc7;
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0,0,0,0.15);
  }
  
  /* Gifts Grid */
  .gifts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 25px;
    padding: 10px;
  }
  
  .gift-card {
    background: white;
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 6px 12px rgba(0,0,0,0.1);
    transition: transform 0.3s;
    border: 3px solid #e0d4ff;
  }
  
  .gift-card:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 10px 20px rgba(0,0,0,0.15);
  }
  
  .gift-emoji {
    font-size: 3.5rem;
    margin-bottom: 15px;
  }
  
  .gift-card h3 {
    color: #5e35b1;
    margin-bottom: 10px;
    font-size: 1.3rem;
  }
  
  .points {
    color: #ff8a65;
    font-weight: bold;
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
  
  .redeem-button {
    background-color: #ff9e80;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: bold;
    width: 100%;
  }
  .redeem-button-disabled{
    background-color: #908d8d;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: not-allowed;
    /* transition: all 0.3s; */
    font-weight: bold;
    width: 100%;
  }
  .redeem-button-disabled:hover{
    cursor: not-allowed;
    background-color: #908d8d;
  }
  
  .redeem-button:hover {
    background-color: #ff7043;
    transform: scale(1.05);
  }
  
  .redeem-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  /* History List */
  .history-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
  }
  
  .history-item {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 15px;
    padding: 15px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-left: 5px solid #b39ddb;
  }
  
  .item-emoji {
    font-size: 2.5rem;
    margin-right: 20px;
    min-width: 60px;
    text-align: center;
  }
  
  .item-details {
    flex: 1 1;
  }
  
  .item-details h3 {
    color: #5e35b1;
    margin-bottom: 5px;
  }
  
  .item-details p {
    color: #666;
    margin: 3px 0;
  }
  
  .status {
    font-weight: bold;
    padding: 3px 10px;
    border-radius: 15px;
    display: inline-block;
  }
  
  .status.open {
    background-color: #fff9c4;
    color: #f57f17;
  }
  
  .status.in-process {
    background-color: #bbdefb;
    color: #1565c0;
  }
  
  .status.delivered {
    background-color: #c8e6c9;
    color: #2e7d32;
  }
  
  /* Toast Notification */
  .kid-toast {
    font-family: 'Comic Sans MS', sans-serif;
    font-size: 1.1rem;
    background-color: #a5d6a7 !important;
    color: #1b5e20 !important;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .gifts-grid {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 15px;
    }
    
    .page-title {
      font-size: 2rem;
    }
    
    .tab-button {
      padding: 10px 15px;
      font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .gifts-grid {
      grid-template-columns: 1fr;
  }
  
  .history-item {
      flex-direction: column;
      text-align: center;
  }
  
  .history-item-image, .history-item-emoji {
      margin-right: 0;
      margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyRewards/StudentReward.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gFAAgF;EAChF,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D,EAAE,kCAAkC;EAChG,SAAS;EACT,aAAa;EACb,iBAAiB,EAAE,uEAAuE;EAC1F,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB,EAAE,8BAA8B;EACjD,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,gCAAgC;AAClE;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;GAMG;;AAEH;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;AAC3D;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,aAAa,EAAE,8BAA8B;EAC7C,wCAAwC,EAAE,iCAAiC;AAC7E;;AAEA;;IAEI,cAAc;IACd,6BAA6B,EAAE,wCAAwC;IACvE,0BAA0B;AAC9B;;AAEA;;GAEG;;AAEH,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,wCAAwC;EACxC,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;MACI,4DAA4D;MAC5D,SAAS;EACb;AACF;EACE;MACI,eAAe;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,uCAAuC;EACzC;;EAEA,eAAe;EACf;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA,uBAAuB;EACvB;IACE,wCAAwC;IACxC,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE;MACE,4DAA4D;MAC5D,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;EACnB;AACF;;AAEA;EACE;MACI,0BAA0B;EAC9B;;EAEA;MACI,sBAAsB;MACtB,kBAAkB;EACtB;;EAEA;MACI,eAAe;MACf,mBAAmB;EACvB;AACF","sourcesContent":["/* Main Container */\n.kid-redeem-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: 'Comic Sans MS', 'Marker Felt', 'Arial Rounded MT Bold', sans-serif;\n  background-color: #f9f7ff;\n  min-height: 100vh;\n}\n\n.page-title {\n  color: #6a4c93;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 2.5rem;\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Tabs */\n.tabs-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  gap: 10px;\n}\n\n.tab-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 50px;\n  background-color: #b8a1e0;\n  color: white;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-weight: bold;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.tab-button.active {\n  background-color: #8a6dc7;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n}\n\n/* Gifts Grid */\n.gifts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Increased from 250px to 300px */\n  gap: 25px;\n  padding: 10px;\n  max-width: 1200px; /* Optional: to prevent cards from becoming too wide on large screens */\n  margin: 0 auto; /* Center the grid */\n}\n\n.gift-card {\n  background: white;\n  border-radius: 15px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n  transition: transform 0.3s;\n  border: 3px solid #e0d4ff;\n  min-height: 400px; /* Ensures consistent height */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Better content distribution */\n}\n\n.gift-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  box-shadow: 0 10px 20px rgba(0,0,0,0.15);\n}\n\n.gift-emoji {\n  font-size: 3.5rem;\n  margin-bottom: 15px;\n}\n\n.gift-card h3 {\n  color: #5e35b1;\n  margin-bottom: 10px;\n  font-size: 1.3rem;\n}\n\n/* .gift-image {\n  max-width: 100%;\n  height: auto;\n  max-height: 150px;\n  object-fit: contain;\n  margin: 0 auto 15px;\n} */\n\n.points {\n  font-weight: bold;\n  color: #6a3093;\n  font-size: 1.1rem;\n  margin: 10px 0;\n}\n\n.redeem-button {\n  background-color: #ff9e80;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  padding: 10px 20px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-weight: bold;\n  width: 100%;\n}\n.terms-conditions {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0.5rem 0;\n  min-height: 3rem; /* Ensure consistent height for cards */\n}\n.redeem-button:hover {\n  background-color: #ff7043;\n  transform: scale(1.05);\n}\n\n.redeem-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Terms & Conditions Button */\n.terms-button {\n  background: none;\n  border: none;\n  color: #6a3093;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin: 5px 0;\n  padding: 0;\n  outline: none; /* Removes the focus outline */\n  -webkit-tap-highlight-color: transparent; /* Removes mobile tap highlight */\n}\n\n.terms-button:hover, \n.terms-button:focus {\n    color: #8a2be2;\n    background-color: transparent; /* Ensures no background color appears */\n    text-decoration: underline;\n}\n\n/* .terms-button:hover {\n  color: #8a2be2;\n} */\n\n/* Terms Modal */\n.terms-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background-color: rgba(0, 0, 0, 0.5); */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.terms-modal {\n  background: white;\n  border-radius: 10px;\n  padding: 20px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */\n}\n\n.terms-content {\n  margin: 15px 0;\n  padding: 10px;\n  border: 1px solid #eee;\n  border-radius: 5px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.term-line {\n  margin: 8px 0;\n  line-height: 1.4;\n}\n\n.close-button {\n  background-color: #6a3093;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.close-button:hover {\n  background-color: #8a2be2;\n}\n\n/* History List */\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 10px;\n}\n\n.history-item {\n  display: flex;\n  align-items: center;\n  background: white;\n  border-radius: 15px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  border-left: 5px solid #b39ddb;\n}\n\n.history-item-image {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 8px;\n  margin-right: 15px;\n}\n\n.history-item-emoji {\n  font-size: 50px;\n  margin-right: 15px;\n}\n\n.item-details {\n  flex: 1;\n}\n\n.item-details h3 {\n  color: #5e35b1;\n  margin-bottom: 5px;\n}\n\n.item-details p {\n  color: #666;\n  margin: 3px 0;\n}\n\n.status {\n  font-weight: bold;\n  padding: 3px 10px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.status.open {\n  background-color: #fff9c4;\n  color: #f57f17;\n}\n\n.status.in-process {\n  background-color: #bbdefb;\n  color: #1565c0;\n}\n\n.status.delivered {\n  background-color: #c8e6c9;\n  color: #2e7d32;\n}\n\n.no-history {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.2rem;\n  color: #6a4c93;\n}\n\n/* Toast Notification */\n.kid-toast {\n  font-family: 'Comic Sans MS', sans-serif;\n  font-size: 1.1rem;\n  background-color: #a5d6a7 !important;\n  color: #1b5e20 !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .gifts-grid {\n      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n      gap: 15px;\n  }\n}\n  .page-title {\n      font-size: 2rem;\n  }\n  \n  .tab-button {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 50px;\n    background-color: #b8a1e0;\n    color: white;\n    font-size: 1.1rem;\n    cursor: pointer;\n    transition: all 0.3s;\n    font-weight: bold;\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  }\n  \n  .tab-button.active {\n    background-color: #8a6dc7;\n    transform: translateY(-3px);\n    box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n  }\n  \n  /* Gifts Grid */\n  .gifts-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 25px;\n    padding: 10px;\n  }\n  \n  .gift-card {\n    background: white;\n    border-radius: 15px;\n    padding: 20px;\n    text-align: center;\n    box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n    transition: transform 0.3s;\n    border: 3px solid #e0d4ff;\n  }\n  \n  .gift-card:hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.15);\n  }\n  \n  .gift-emoji {\n    font-size: 3.5rem;\n    margin-bottom: 15px;\n  }\n  \n  .gift-card h3 {\n    color: #5e35b1;\n    margin-bottom: 10px;\n    font-size: 1.3rem;\n  }\n  \n  .points {\n    color: #ff8a65;\n    font-weight: bold;\n    font-size: 1.2rem;\n    margin-bottom: 20px;\n  }\n  \n  .redeem-button {\n    background-color: #ff9e80;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    padding: 10px 20px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s;\n    font-weight: bold;\n    width: 100%;\n  }\n  .redeem-button-disabled{\n    background-color: #908d8d;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    padding: 10px 20px;\n    font-size: 1rem;\n    cursor: not-allowed;\n    /* transition: all 0.3s; */\n    font-weight: bold;\n    width: 100%;\n  }\n  .redeem-button-disabled:hover{\n    cursor: not-allowed;\n    background-color: #908d8d;\n  }\n  \n  .redeem-button:hover {\n    background-color: #ff7043;\n    transform: scale(1.05);\n  }\n  \n  .redeem-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n  }\n  \n  /* History List */\n  .history-list {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    padding: 10px;\n  }\n  \n  .history-item {\n    display: flex;\n    align-items: center;\n    background: white;\n    border-radius: 15px;\n    padding: 15px;\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n    border-left: 5px solid #b39ddb;\n  }\n  \n  .item-emoji {\n    font-size: 2.5rem;\n    margin-right: 20px;\n    min-width: 60px;\n    text-align: center;\n  }\n  \n  .item-details {\n    flex: 1;\n  }\n  \n  .item-details h3 {\n    color: #5e35b1;\n    margin-bottom: 5px;\n  }\n  \n  .item-details p {\n    color: #666;\n    margin: 3px 0;\n  }\n  \n  .status {\n    font-weight: bold;\n    padding: 3px 10px;\n    border-radius: 15px;\n    display: inline-block;\n  }\n  \n  .status.open {\n    background-color: #fff9c4;\n    color: #f57f17;\n  }\n  \n  .status.in-process {\n    background-color: #bbdefb;\n    color: #1565c0;\n  }\n  \n  .status.delivered {\n    background-color: #c8e6c9;\n    color: #2e7d32;\n  }\n  \n  /* Toast Notification */\n  .kid-toast {\n    font-family: 'Comic Sans MS', sans-serif;\n    font-size: 1.1rem;\n    background-color: #a5d6a7 !important;\n    color: #1b5e20 !important;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .gifts-grid {\n      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n      gap: 15px;\n    }\n    \n    .page-title {\n      font-size: 2rem;\n    }\n    \n    .tab-button {\n      padding: 10px 15px;\n      font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gifts-grid {\n      grid-template-columns: 1fr;\n  }\n  \n  .history-item {\n      flex-direction: column;\n      text-align: center;\n  }\n  \n  .history-item-image, .history-item-emoji {\n      margin-right: 0;\n      margin-bottom: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
